export const enableDocumentScrollSDKFactory = api => ({
    setBackgroundScroll: value => api.setProps({ isDocumentScrollEnabled: value }),
});
//# sourceMappingURL=enableDocumentScrollSDKFactory.js.map